import api from '@/api/journeyDay-api'

const state = {
  items: [],
  currentJourney: null,
  totalHours: '00:00',
  loading: false,
  error: null,
  userSchedules: [],
}

const mutations = {
  setItems(state, val) {
    state.items = val
  },
  setCurrentJourney(state, val) {
    state.currentJourney = val
  },
  setTotalHours(state, val) {
    state.totalHours = val
  },
  setLoading(state, val) {
    state.loading = val
  },
  setError(state, val) {
    state.error = val
  },
  setUserSchedules(state, val) {
    state.userSchedules = val
  },
}

const actions = {
  async startJourney({ commit }, params) {
    commit('setLoading', true)
    try {
      const response = await api.create(params)
      // Si tiene código (falta_motivo), devolver la respuesta tal cual
      if (response.data.code) {
        return response.data
      }
      commit('setCurrentJourney', response.data.data)
      commit('app/loading', false, { root: true })
      return response.data.data
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Error al iniciar jornada')
      commit('notifications', {
        title: 'Error al iniciar jornada',
        variant: 'danger',
      }, { root: true })
      commit('setShowNotifications', true, { root: true })
      throw error
    } finally {
      commit('setLoading', false)
    }
  },

  async getCurrentJourney({ commit }) {
    commit('setLoading', true)
    try {
      const response = await api.getCurrent()
      // Buscar la jornada en progreso (hour_fin === null)
      const { data } = response.data
      const { meta } = response.data
      let currentJourney = null

      if (Array.isArray(data)) {
        // Guardar todas las jornadas
        commit('setItems', data)
        // Buscar la primera jornada que está en progreso (sin hour_fin)
        currentJourney = data.find(j => j.hour_fin === null) || null
      }

      // Guardar el tiempo total acumulado
      if (meta && meta.total_hours) {
        commit('setTotalHours', meta.total_hours)
      }

      commit('setCurrentJourney', currentJourney)
      return currentJourney
    } catch (error) {
      commit('setCurrentJourney', null)
    } finally {
      commit('setLoading', false)
    }
  },

  async fetchUserSchedules({ commit }) {
    try {
      const response = await api.getUserSchedules()
      commit('setUserSchedules', response.data.data || [])
    } catch (error) {
      commit('setUserSchedules', [])
    }
  },

  async completeJourney({ commit }, params) {
    commit('setLoading', true)
    try {
      const response = await api.complete(params)
      // Si tiene código (falta_motivo), devolver la respuesta tal cual
      if (response.data.code) {
        return response.data
      }
      commit('setCurrentJourney', null)
      commit('notifications', {
        title: 'Jornada completada exitosamente',
        variant: 'success',
      }, { root: true })
      commit('setShowNotifications', true, { root: true })
      return response.data.data
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Error al completar jornada')
      commit('notifications', {
        title: 'Error al completar jornada',
        variant: 'danger',
      }, { root: true })
      commit('setShowNotifications', true, { root: true })
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
}

const getters = {
  getItems: state => state.items,
  getCurrentJourney: state => state.currentJourney,
  getTotalHours: state => state.totalHours,
  getLoading: state => state.loading,
  getError: state => state.error,
  getUserSchedules: state => state.userSchedules,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
